import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CommentsSection />
        <CardsSection />
        <RankingSection />
        <FaqSection />
        <TopicsSection />
        <AppSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <UpdatesSection />
        <MediaSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}